<template>
  <el-main class="common-main">
    <div class="container success">
      <i class="el-icon-success success-icon"></i>
      <div class="success-title">答题完成</div>
      <div class="success-info-box">
        <div class="success-info">
          <div style="font-weight: bold">试卷：{{ result.paper ? result.paper.title : '无法找到该试卷' }}</div>
          <div>得分：{{ result.num }}</div>
          <div>答题时长：{{ SecondToDate(result.time) }}</div>
        </div>
      </div>
      <div class="success-button">
        <el-button type="primary" @click="goCourse">前往我的课程</el-button>
      </div>
    </div>
  </el-main>
</template>

<script>
import {authRequest} from "@/utils/request";

export default {
  name: "testSuccess",
  head: {
    title: "答题结果"
  },
  data() {
    return {
      id: '',
      result: ''
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getResult()
  },
  methods: {
    goCourse() {
      this.$router.push({path: '/user/course'})
    },
    async getResult() {
      try {
        let response = await authRequest('test/' + this.id, {
          method: 'GET'
        })
        console.log(response)
        this.result = response.data.data
      } catch (e) {

      }
    },
    SecondToDate(msd) {
      var time = msd
      if (null != time && "" !== time){
        if (time > 60 && time < 60 * 60) {
          time = parseInt(time / 60.0) + "分钟" + parseInt((parseFloat(time / 60.0) -
              parseInt(time / 60.0)) * 60) + "秒";
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time = parseInt(time / 3600.0) + "小时" + parseInt((parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) * 60) + "分钟" +
              parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
                  parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
        } else if (time >= 60 * 60 * 24) {
          time = parseInt(time / 3600.0 / 24) + "天" + parseInt((parseFloat(time / 3600.0 / 24) -
              parseInt(time / 3600.0 / 24)) * 24) + "小时" + parseInt((parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) * 60) + "分钟" +
              parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
                  parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
        } else {
          time = parseInt(time) + "秒";
        }
      }
      return time;
    }
  }
}
</script>

<style scoped>
.success {
  text-align: center;
  background-color: #ffffff;
  border-radius: 6px;
  padding: 30px;
}

.success-title {
  color: #333333;
  font-weight: bold;
  font-size: 20px;
}

.success-button {
  margin-top: 30px;
}

.success-icon {
  font-size: 100px;
  color: #2aacb2;
}

.success-info-box {
  display: flex;
  justify-content: center;
}

.success-info {
  background-color: #f3f3f3;
  margin-top: 30px;
  width: 600px;
  padding: 20px;
  border-radius: 6px;
  text-align: left;
}
</style>